// Config is resolved at RUNTIME from window.__APP_CONFIG__ — written into
// /config.js at container start by the nginx entrypoint hook
// (inject-runtime-config.sh) from the container's environment. It falls back to
// build-time import.meta.env so local dev / `vite preview` keep working from
// .env files. Nothing is baked into the production image.
type RuntimeEnv = Partial<Record<keyof ImportMetaEnv, string>>

const runtimeEnv: RuntimeEnv =
    (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

function readEnv(
    key: keyof ImportMetaEnv,
    buildTimeValue: string | undefined
): string | undefined {
    const runtimeValue = runtimeEnv[key]
    if (runtimeValue !== undefined && runtimeValue !== '') return runtimeValue
    return buildTimeValue
}

export const envConfig = {
    // REST base URL for heritage-app-backend (origin only, no path). Empty
    // string falls back to the local default in shared/api/rest/config.ts.
    apiBaseUrl: readEnv('VITE_API_BASE_URL', import.meta.env.VITE_API_BASE_URL) ?? '',
    auth0Domain: readEnv('VITE_AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN) ?? '',
    clientId: readEnv('VITE_AUTH0_CLIENT_ID', import.meta.env.VITE_AUTH0_CLIENT_ID) ?? '',
    clientSecret:
        readEnv('VITE_AUTH0_CLIENT_SECRET', import.meta.env.VITE_AUTH0_CLIENT_SECRET) ?? '',
    auth0PublicKey:
        readEnv('VITE_AUTH0_PUBLIC_KEY', import.meta.env.VITE_AUTH0_PUBLIC_KEY) ?? '',
    auth0BaseUrl: readEnv('VITE_AUTH0_BASE_URL', import.meta.env.VITE_AUTH0_BASE_URL) ?? '',
    auth0IssuerBaseUrl:
        readEnv('VITE_AUTH0_ISSUER_BASE_URL', import.meta.env.VITE_AUTH0_ISSUER_BASE_URL) ?? '',
    defaultParentRoleId:
        readEnv('VITE_PARENT_ROLE_ID', import.meta.env.VITE_PARENT_ROLE_ID) ?? '',
    cloudinaryCloudName:
        readEnv('VITE_CLOUDINARY_CLOUD_NAME', import.meta.env.VITE_CLOUDINARY_CLOUD_NAME) ?? '',
    cloudinaryApiKey:
        readEnv('VITE_CLOUDINARY_API_KEY', import.meta.env.VITE_CLOUDINARY_API_KEY) ?? '',
    cloudinaryApiSecret:
        readEnv('VITE_CLOUDINARY_API_SECRET', import.meta.env.VITE_CLOUDINARY_API_SECRET) ?? '',
    cloudinaryUploadPreset:
        readEnv(
            'VITE_CLOUDINARY_UPLOAD_PRESET',
            import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET
        ) ?? '',
    cloudinaryFolderName:
        readEnv(
            'VITE_CLOUDINARY_IMAGE_FOLDER_NAME',
            import.meta.env.VITE_CLOUDINARY_IMAGE_FOLDER_NAME
        ) ?? '',
} as const

export type EnvConfig = typeof envConfig
